<template>
  <div class="g-page">
    <div class="content-container">

      <!-- HEADER -->
      <div class="header-row">
        <h2 class="page-title">{{ $t("Maxsulotlar") }}</h2>
        <div class="header-actions">

          <!-- Qidiruv -->
          <div class="search-wrapper">
            <b-icon icon="search" class="search-icon"></b-icon>
            <input type="text" class="modern-search" :placeholder="$t('Qidiruv...')" v-model="filter"
              @input="onSearchInput" ref="inputText1" />
          </div>

          <!-- 🔍 Dublikat shtrix kodlarni tekshirish -->
          <button class="tool-btn dup-fab" @click="openDuplicateModal()" title="Dublikat shtrix kodlarni topish va tuzatish">
            <b-icon icon="search" font-scale="1.4"></b-icon>
            <span class="dup-label">Dublikatlar</span>
          </button>

          <!-- 🛠 Excel'dan narxlarni tuzatish -->
          <button class="tool-btn fix-prices-fab" @click="openFixPricesModal()"
            title="Excel fayldan kelish narxi va sotish narxlarini tuzatish">
            <b-icon icon="tools" font-scale="1.4"></b-icon>
            <span class="fix-prices-label">Narxlarni tuzatish</span>
          </button>

          <!-- Yashirin fayl input -->
          <input ref="fixPricesFileInput" type="file" accept=".xlsx" style="display:none"
            @change="onFixPricesFileChange" />

          <!-- 0️⃣ Tannarxi 0 bo'lgan mahsulotlar -->
          <button class="tool-btn zero-cost-fab" @click="openZeroCostModal()"
            title="Tannarxi 0 bo'lib qolgan mahsulotlarni topish va tuzatish">
            <b-icon icon="exclamation-octagon" font-scale="1.4"></b-icon>
            <span class="zero-cost-label">Tannarxi 0</span>
          </button>

          <!-- ⚠️ Tannarxi sotuv (chakana) narxidan oshib ketgan mahsulotlar -->
          <button class="tool-btn cost-high-fab" @click="openCostHighModal()"
            title="Tannarxi chakana narxidan oshib ketgan mahsulotlarni topish va tuzatish">
            <b-icon icon="graph-up-arrow" font-scale="1.4"></b-icon>
            <span class="cost-high-label">Tannarx &gt; Sotuv</span>
          </button>

          <!-- 🏷 Tanlangan shtrixlar (modal) — kattaroq badge bilan -->
          <button class="tool-btn barcode-fab" :class="{ active: barcodeSelection.length > 0 }"
            @click="showBarcodeModal = true"
            :title="`Shtrix chiqarish (${barcodeSelection.length} ta)`">
            <b-icon icon="upc" font-scale="1.6"></b-icon>
            <span v-if="barcodeSelection.length" class="badge-count">{{ barcodeSelection.length }}</span>
          </button>

          <!-- 🗑 Tanlanganlarni o'chirish -->
          <button v-if="selectedIds.length > 0" type="button" class="bulk-del-btn"
            @click="bulkDelete()" :disabled="bulkDeleting"
            :title="`Tanlangan ${selectedIds.length} ta mahsulotni o'chirish`">
            <b-icon :icon="bulkDeleting ? 'arrow-repeat' : 'trash'"></b-icon>
            {{ bulkDeleting ? "O'chirilmoqda..." : `O'chirish (${selectedIds.length})` }}
          </button>

          <!-- Qo'shish -->
          <router-link :to="{ name: 'Товар модал create' }">
            <button type="button" class="add-btn" v-b-modal.modal-product>
              <b-icon icon="plus-circle-fill"></b-icon> {{ $t("Qo'shish") }}<sup>ins</sup>
            </button>
          </router-link>
        </div>
      </div>

      <!-- JADVAL -->
      <div class="table-card">
        <div class="table-wrapper">
          <table class="custom-table">
            <thead>
              <tr>
                <th style="width: 36px; text-align:center;">
                  <input type="checkbox" class="row-check" :checked="allPageSelected"
                    :indeterminate.prop="somePageSelected && !allPageSelected"
                    @change="toggleSelectAll($event)" title="Sahifadagi o'chirib bo'ladiganlarni tanlash" />
                </th>
                <th style="width: 60px"></th>
                <th>{{ $t("Номи") }}</th>
                <th style="width: 110px">{{ $t("Артикул") }}</th>
                <th class="th-right">{{ $t("Қолдиқ") }}</th>
                <th class="th-right">Tannarx</th>
                <th class="th-right">{{ $t("Чакана") }} {{ $t("Нарх") }}</th>
                <th class="th-right">{{ $t("Чакана") }} {{ $t("Нарх") }}$</th>
                <th class="th-right">{{ $t("Улгуржи") }} {{ $t("Нарх") }}</th>
                <th class="th-right">{{ $t("Улгуржи") }} {{ $t("Нарх") }}$</th>
                <th style="width: 140px; text-align: center;">{{ $t("AMALLAR") }}</th>
              </tr>
            </thead>
            <tbody>
              <!-- Orqaga qaytish -->
              <tr class="navigation-row" @click="Productlist(parent)">
                <td></td>
                <td>
                  <b-icon icon="arrow-left-circle-fill" variant="secondary"></b-icon>
                </td>
                <td>
                  <button type="button" class="go-back-btn">..</button>
                </td>
                <td colspan="8"></td>
              </tr>

              <!-- Ma'lumotlar -->
              <span style="display: contents;" v-for="(item, index) in filteredRows" :key="index">
                <tr :class="{ 'folder-row': item.is_folder, 'row-selected': isSelected(item.id) }">
                  <td style="text-align:center;">
                    <input v-if="!item.is_folder && !item.used" type="checkbox" class="row-check"
                      :checked="isSelected(item.id)" @change="toggleSelect(item.id)" @click.stop />
                    <b-icon v-else-if="item.used" icon="lock-fill" class="lock-icon"
                      title="Savdoda sotilgan — o'chirib bo'lmaydi"></b-icon>
                  </td>
                  <td @click="Select(item)" style="cursor: pointer;">
                    <span v-if="item.is_folder">
                      <b-icon icon="folder-fill" variant="warning" font-scale="1.1"></b-icon>
                    </span>
                    <span class="id-text">{{ item.id }}</span>
                  </td>
                  <td @click="Select(item)" style="cursor: pointer;">
                    <button type="button" :class="['item-name', { 'folder-name': item.is_folder }]">
                      <span v-if="item.parent_id > 0" style="padding:0 15px;"></span>
                      {{ item.extra_name }}
                    </button>
                  </td>
                  <td class="td-code" @click="Select(item)" style="cursor: pointer;">
                    <span v-if="item.code" class="code-badge">{{ item.code }}</span>
                    <span v-else class="code-empty">—</span>
                  </td>
                  <td class="td-right td-balance" @click="Select(item)" style="cursor: pointer;">
                    {{ item.balance | numFormat }}
                  </td>
                  <!-- TANNARX — dollar bo'lsa "$ + ≈so'm", aks holda so'mda -->
                  <td class="td-right" @click="Select(item)" style="cursor: pointer;">
                    <template v-if="item.price_register && Number(item.price_register.body_price_raw) > 0">
                      <span v-if="Number(item.price_register.cost_currency) === 2" class="cost-usd">
                        {{ item.price_register.body_price_raw | numFormat }} $
                        <small class="cost-sub">≈ {{ item.price_register.body_price | numFormat }}</small>
                      </span>
                      <span v-else class="cost-sum">{{ item.price_register.body_price | numFormat }}</span>
                    </template>
                    <span v-else class="code-empty">—</span>
                  </td>
                  <td class="td-right" @click="Select(item)" style="cursor: pointer;">
                    <span v-if="item.price_register">
                      {{ item.price_register.chakana_price | numFormat }}
                    </span>
                  </td>
                  <td class="td-right" @click="Select(item)" style="cursor: pointer;">
                    <span v-if="item.price_register">
                      {{ item.price_register.chakana_dollar_price | numFormat }}
                    </span>
                  </td>
                  <td class="td-right" @click="Select(item)" style="cursor: pointer;">
                    <span v-if="item.price_register">
                      {{ item.price_register.optom_price | numFormat }}
                    </span>
                  </td>
                  <td class="td-right" @click="Select(item)" style="cursor: pointer;">
                    <span v-if="item.price_register">
                      {{ item.price_register.optom_dollar_price | numFormat }}
                    </span>
                  </td>
                  <td>
                    <div class="actions">
                      <button type="button"
                        class="icon-btn barcode"
                        :class="{ 'selected': getBarcodeCount(item.id) > 0 }"
                        :title="getBarcodeCount(item.id) > 0 ? `Tanlangan: ${getBarcodeCount(item.id)} ta (yana qo'shish)` : 'Shtrixga qo\'shish'"
                        v-if="!item.is_folder" @click="addToBarcodeSelection(item)">
                        <b-icon icon="upc"></b-icon>
                        <span v-if="getBarcodeCount(item.id) > 0" class="row-badge">
                          {{ getBarcodeCount(item.id) }}
                        </span>
                      </button>
                      <router-link :to="{ name: 'Товар модал update', params: { id: item.id } }">
                        <button type="button" class="icon-btn edit" @click="$store.state.parent_id=item.parent_id">
                          <b-icon icon="pencil-square"></b-icon>
                        </button>
                      </router-link>
                      <button v-if="!item.used" type="button" class="icon-btn del" @click="Producttrash(item.id)"
                        title="O'chirish">
                        <b-icon icon="trash"></b-icon>
                      </button>
                      <router-link :to="{ name: 'Товар модал create', params: { copy: item.id } }">
                        <button type="button" class="icon-btn copy">
                          <b-icon icon="back"></b-icon>
                        </button>
                      </router-link>
                    </div>
                  </td>
                </tr>
              </span>

              <!-- Bo'sh holat -->
              <tr v-if="filteredRows.length === 0">
                <td colspan="11" class="empty-row">{{ $t("Ma'lumot topilmadi") }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- FOOTER with pagination -->
        <div class="table-footer">
          <div class="info">
            Jami: <b>{{ totalCount }}</b> ta mahsulot
            <span class="sep">·</span>
            Sahifa: <b>{{ page }}</b> / {{ totalPages }}
          </div>
          <div class="paginator">
            <label class="per-page">
              Sahifada:
              <select v-model.number="limit" @change="onLimitChange">
                <option :value="25">25</option>
                <option :value="50">50</option>
                <option :value="100">100</option>
                <option :value="200">200</option>
                <option :value="500">500</option>
              </select>
            </label>
            <button class="page-btn" :disabled="page<=1" @click="gotoPage(1)" title="Birinchi">«</button>
            <button class="page-btn" :disabled="page<=1" @click="gotoPage(page-1)" title="Oldingi">‹</button>
            <button
              v-for="p in visiblePages"
              :key="p"
              class="page-btn"
              :class="{ active: p === page }"
              @click="gotoPage(p)"
            >{{ p }}</button>
            <button class="page-btn" :disabled="page>=totalPages" @click="gotoPage(page+1)" title="Keyingi">›</button>
            <button class="page-btn" :disabled="page>=totalPages" @click="gotoPage(totalPages)" title="Oxirgi">»</button>
          </div>
        </div>
      </div>
    </div>

    <!-- ═══════════════ 🏷 SHTRIX CHIQARISH MODAL ═══════════════ -->
    <div v-if="showBarcodeModal" class="bc-overlay" @click.self="showBarcodeModal = false">
      <div class="bc-modal">
        <div class="bc-head">
          <h3 class="bc-title">🏷 Shtrix kod chiqarish ({{ barcodeSelection.length }} ta)</h3>
          <button class="bc-close" @click="showBarcodeModal = false">&times;</button>
        </div>

        <div class="bc-body">
          <div class="bc-options">
            <div class="bc-opt">
              <label class="bc-label">Narx turi</label>
              <select v-model="barcodePriceType" class="bc-select">
                <option value="chakana">Chakana</option>
                <option value="optom">Optom</option>
              </select>
            </div>
            <div class="bc-opt">
              <label class="bc-toggle">
                <input type="checkbox" v-model="barcodeShowPrice"> Narxni chop etish
              </label>
            </div>

            <!-- 🎯 Ommaviy son o'rnatish -->
            <div class="bc-opt bc-bulk">
              <label class="bc-label">Hammaga son</label>
              <div class="bc-bulk-row">
                <input v-model.number="barcodeBulkCount" type="number" min="0"
                  class="bc-qty" placeholder="5" @keyup.enter="applyBarcodeBulk()" />
                <button class="bc-btn-apply" @click="applyBarcodeBulk()" title="Hammasiga qo'llash">
                  Qo'llash
                </button>
              </div>
            </div>

            <!-- 🎯 Avto-kod: bo'sh va dublikat shtrixlarga noyob shtrix berish -->
            <div class="bc-opt" v-if="barcodeSelection.length > 0">
              <button class="bc-btn-auto" :disabled="autoGenerating" @click="autoGenerateBarcodes()"
                :title="autoFixTitle">
                <b-icon :icon="autoGenerating ? 'arrow-repeat' : 'magic'"></b-icon>
                {{ autoGenerating ? 'Yaratilmoqda...' : `Avto-kod${autoFixCount > 0 ? ` (${autoFixCount})` : ''}` }}
              </button>
            </div>

            <div class="bc-opt" style="margin-left:auto">
              <button class="bc-btn-clear" @click="barcodeSelection = []">
                <b-icon icon="trash"></b-icon> Tozalash
              </button>
            </div>
          </div>

          <div v-if="barcodeSelection.length === 0" class="bc-empty">
            Ro'yxat bo'sh. Mahsulot ro'yxatidan 🏷 tugmasini bosib qo'shing.
          </div>
          <table v-else class="bc-table">
            <thead>
              <tr>
                <th style="width:40px">№</th>
                <th>Mahsulot</th>
                <th style="width:150px">Shtrix</th>
                <th style="width:120px">Narx</th>
                <th style="width:100px">Soni</th>
                <th style="width:50px"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(it, i) in barcodeSelection" :key="it.id">
                <td>{{ i + 1 }}</td>
                <td>
                  <div class="bc-pname">{{ it.name }}</div>
                  <div v-if="!it.shtrix_kod" class="bc-warn">⚠️ Shtrix kod yo'q</div>
                </td>
                <td class="bc-mono">{{ it.shtrix_kod || '—' }}</td>
                <td>{{ Number(barcodePriceType === 'chakana' ? it.chakana_price : it.optom_price).toLocaleString('ru-RU') }}</td>
                <td><input v-model.number="it.count" type="number" min="1" class="bc-qty" /></td>
                <td>
                  <button class="bc-btn-x" @click="barcodeSelection.splice(i, 1)" title="O'chirish">
                    <b-icon icon="x-lg"></b-icon>
                  </button>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="4" style="text-align:right; font-weight:800">JAMI stikerlar:</td>
                <td colspan="2" style="font-weight:900; color:#5850ec">
                  {{ barcodeSelection.reduce((s, it) => s + Number(it.count || 0), 0) }} ta
                </td>
              </tr>
            </tfoot>
          </table>
        </div>

        <div class="bc-foot">
          <button class="bc-btn-cancel" @click="showBarcodeModal = false">Bekor</button>
          <button class="bc-btn-print"
            :disabled="barcodeSelection.length === 0 || !barcodeSelection.some(it => it.shtrix_kod && it.count > 0)"
            @click="printBarcodes()">
            <b-icon icon="printer-fill"></b-icon> Chop etish
          </button>
        </div>
      </div>
    </div>

    <!-- ═══════════════ 🔍 DUBLIKAT SHTRIX MODAL ═══════════════ -->
    <div v-if="showDupModal" class="bc-overlay" @click.self="showDupModal = false">
      <div class="bc-modal dup-modal">
        <div class="bc-head">
          <h3 class="bc-title">
            🔍 Dublikat shtrix kodlar
            <span v-if="!dupLoading" class="dup-stats">
              ({{ dupGroups.length }} ta guruh · {{ dupTotalProducts }} ta mahsulot)
            </span>
          </h3>
          <button class="bc-close" @click="showDupModal = false">&times;</button>
        </div>

        <div class="bc-body">
          <div v-if="dupLoading" class="text-center" style="padding: 40px">
            <b-spinner variant="primary"></b-spinner>
            <div class="mt-2 text-muted">Dublikatlar qidirilmoqda...</div>
          </div>

          <div v-else-if="dupGroups.length === 0" class="bc-empty" style="color:#10b981">
            ✅ Dublikat shtrix kodlar topilmadi — barchasi noyob.
          </div>

          <div v-else>
            <div class="dup-info-bar">
              <div>
                <b>{{ dupGroups.length }}</b> ta guruh aniqlandi, jami <b>{{ dupTotalProducts }}</b> ta mahsulot.
                Avto-tuzatish har biriga <code>25 + mahsulot ID</code> formuli bo'yicha noyob shtrix beradi.
              </div>
              <button class="bc-btn-auto" :disabled="dupFixing"
                @click="autoFixAllDuplicates()">
                <b-icon :icon="dupFixing ? 'arrow-repeat' : 'magic'"></b-icon>
                {{ dupFixing ? 'Tuzatilmoqda...' : 'Hammasini avto-tuzatish' }}
              </button>
            </div>

            <div class="dup-list">
              <div v-for="(grp, gi) in dupGroups" :key="grp.shtrix_kod" class="dup-group">
                <div class="dup-group-head">
                  <span class="dup-group-num">#{{ gi + 1 }}</span>
                  <span class="dup-shtrix-tag">📛 {{ grp.shtrix_kod }}</span>
                  <span class="dup-count">{{ grp.count }} ta mahsulot</span>
                  <button class="dup-fix-group" :disabled="dupFixing"
                    @click="autoFixGroup(grp)" title="Faqat shu guruhni tuzatish">
                    <b-icon icon="magic"></b-icon> Tuzatish
                  </button>
                </div>
                <div class="dup-products">
                  <div v-for="p in grp.products" :key="p.id" class="dup-product">
                    <span class="dup-pid">#{{ p.id }}</span>
                    <span class="dup-pname">{{ p.extra_name || p.name }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="bc-foot">
          <button class="bc-btn-cancel" @click="showDupModal = false">Yopish</button>
          <button class="bc-btn-apply" @click="loadDuplicates()" :disabled="dupLoading">
            <b-icon icon="arrow-clockwise"></b-icon> Yangilash
          </button>
        </div>
      </div>
    </div>

    <!-- ═══════════════ 🛠 NARXLARNI TUZATISH MODAL ═══════════════ -->
    <div v-if="showFixPricesModal" class="bc-overlay" @click.self="showFixPricesModal = false">
      <div class="bc-modal fix-prices-modal">
        <div class="bc-head">
          <h3 class="bc-title">🛠 Excel'dan narxlarni tuzatish</h3>
          <button class="bc-close" @click="showFixPricesModal = false">&times;</button>
        </div>

        <div class="bc-body">
          <div v-if="!fixPricesResult" class="fix-info">
            <p><b>Bu nima qiladi?</b></p>
            <ul>
              <li>Excel'dagi har mahsulotni nom (<code>extra_name</code>) bo'yicha topadi</li>
              <li><b>Kelish narxi</b> (Цена поставки) va <b>Sotish narxi</b> (Цена продажи) ni yangilaydi</li>
              <li>"X-Y" diapazon formatda <b>oxirgi (yangi)</b> qiymatni oladi</li>
              <li>⚠️ Yangi mahsulot YARATMAYDI, ombor qoldig'iga TEGMAYDI — faqat narxlarni to'g'rilaydi</li>
              <li>Eski savdolar tegmaydi (foyda snapshoti saqlanadi)</li>
            </ul>

            <div class="fix-file-pick">
              <button class="bc-btn-auto" :disabled="fixPricesLoading" @click="$refs.fixPricesFileInput.click()">
                <b-icon :icon="fixPricesLoading ? 'arrow-repeat' : 'file-earmark-arrow-up'"></b-icon>
                {{ fixPricesLoading ? 'Yuklanmoqda...' : 'Excel faylni tanlash (.xlsx)' }}
              </button>
              <div v-if="fixPricesFile" class="fix-file-name">
                Tanlangan: <b>{{ fixPricesFile.name }}</b>
                <button class="fix-clear-btn" @click="fixPricesFile = null">&times;</button>
              </div>
            </div>
          </div>

          <div v-else class="fix-result">
            <div class="fix-result-row ok">
              <b-icon icon="check-circle-fill"></b-icon>
              Excel qatorlari: <b>{{ fixPricesResult.total_excel_rows }}</b>
            </div>
            <div class="fix-result-row ok">
              <b-icon icon="search"></b-icon>
              Bazadan topildi: <b>{{ fixPricesResult.matched }}</b>
            </div>
            <div class="fix-result-row ok">
              <b-icon icon="check2-square"></b-icon>
              Yangilandi: <b>{{ fixPricesResult.updated }}</b>
            </div>
            <div class="fix-result-row" v-if="fixPricesResult.no_change">
              <b-icon icon="dash-circle"></b-icon>
              O'zgarmadi (avval to'g'ri edi): <b>{{ fixPricesResult.no_change }}</b>
            </div>
            <div class="fix-result-row warn" v-if="fixPricesResult.not_found">
              <b-icon icon="exclamation-triangle-fill"></b-icon>
              Bazada topilmadi: <b>{{ fixPricesResult.not_found }}</b>
            </div>
            <div v-if="fixPricesResult.not_found_sample && fixPricesResult.not_found_sample.length" class="fix-notfound-list">
              <b>Topilmagan mahsulotlar (birinchi {{ fixPricesResult.not_found_sample.length }} ta):</b>
              <ul>
                <li v-for="(nm, i) in fixPricesResult.not_found_sample" :key="i">{{ nm }}</li>
              </ul>
              <small class="text-muted">Bu mahsulotlar bazada Excel'dagi to'liq nomi bilan topilmadi.</small>
            </div>
          </div>
        </div>

        <div class="bc-foot">
          <button v-if="fixPricesResult" class="bc-btn-apply" @click="resetFixPricesModal()">
            <b-icon icon="arrow-clockwise"></b-icon> Yana
          </button>
          <button class="bc-btn-cancel" @click="showFixPricesModal = false">Yopish</button>
          <button v-if="!fixPricesResult" class="bc-btn-print"
            :disabled="!fixPricesFile || fixPricesLoading"
            @click="submitFixPrices()">
            <b-icon :icon="fixPricesLoading ? 'arrow-repeat' : 'check-all'"></b-icon>
            {{ fixPricesLoading ? 'Yuklanmoqda...' : 'Tuzatishni boshlash' }}
          </button>
        </div>
      </div>
    </div>

    <!-- ═══════════════ 0️⃣ TANNARXI 0 MODAL ═══════════════ -->
    <div v-if="showZeroCostModal" class="bc-overlay" @click.self="showZeroCostModal = false">
      <div class="bc-modal zero-cost-modal">
        <div class="bc-head">
          <h3 class="bc-title">
            0️⃣ Tannarxi 0 bo'lgan mahsulotlar
            <span v-if="!zeroCostLoading" class="dup-stats">({{ zeroCostTotal }} ta)</span>
          </h3>
          <button class="bc-close" @click="showZeroCostModal = false">&times;</button>
        </div>

        <div class="bc-body">
          <!-- Qidiruv + valyuta -->
          <div class="zc-toolbar">
            <div class="search-wrapper" style="flex:1">
              <b-icon icon="search" class="search-icon"></b-icon>
              <input type="text" class="modern-search" style="width:100%"
                :placeholder="$t('Qidiruv...')" v-model="zeroCostKeyword" @input="onZeroCostSearch" />
            </div>
            <div class="zc-pickedinfo" v-if="zeroCostEditedCount > 0">
              <b-icon icon="pencil-fill"></b-icon> {{ zeroCostEditedCount }} ta kiritildi
            </div>
            <button class="bc-btn-print" :disabled="zeroCostSaving || zeroCostEditedCount === 0"
              @click="saveZeroCost()">
              <b-icon :icon="zeroCostSaving ? 'arrow-repeat' : 'check-all'"></b-icon>
              {{ zeroCostSaving ? 'Saqlanmoqda...' : `Saqlash (${zeroCostEditedCount})` }}
            </button>
          </div>

          <div v-if="zeroCostLoading" class="text-center" style="padding:40px">
            <b-spinner variant="primary"></b-spinner>
            <div class="mt-2 text-muted">Yuklanmoqda...</div>
          </div>

          <div v-else-if="zeroCostList.length === 0" class="bc-empty" style="color:#10b981">
            ✅ Tannarxi 0 bo'lgan mahsulot topilmadi.
          </div>

          <table v-else class="bc-table zc-table">
            <thead>
              <tr>
                <th style="width:40px">№</th>
                <th style="width:60px">ID</th>
                <th>Mahsulot</th>
                <th style="width:90px" class="th-right">Qoldiq</th>
                <th style="width:110px" class="th-right">Chakana</th>
                <th style="width:150px">Yangi tannarx</th>
                <th style="width:110px">Valyuta</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(it, i) in zeroCostList" :key="it.id"
                :class="{ 'zc-edited': costNum(it) > 0 }">
                <td>{{ (zeroCostPage - 1) * zeroCostLimit + i + 1 }}</td>
                <td class="id-text" style="float:none">{{ it.id }}</td>
                <td>
                  <div class="bc-pname">{{ it.extra_name || it.name }}</div>
                  <div v-if="it.code" class="zc-code">{{ it.code }}</div>
                </td>
                <td class="td-right" :style="{ color: Number(it.balance) > 0 ? '#2563eb' : '#cbd5e1' }">
                  {{ it.balance | numFormat }}
                </td>
                <td class="td-right">{{ it.chakana_price | numFormat }}</td>
                <td>
                  <input :value="it.new_body" type="text" inputmode="decimal"
                    class="zc-input" placeholder="0"
                    @input="onCostInput(it, $event.target.value)"
                    @keyup.enter="focusNextCost(i)"
                    :ref="'costInput' + i" />
                </td>
                <td>
                  <select v-model.number="it.cost_currency" class="bc-select zc-cur">
                    <option :value="1">so'm</option>
                    <option :value="2">$</option>
                  </select>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="bc-foot">
          <div class="paginator" v-if="!zeroCostLoading && zeroCostTotalPages > 1" style="margin-right:auto">
            <button class="page-btn" :disabled="zeroCostPage<=1" @click="gotoZeroCostPage(zeroCostPage-1)">‹</button>
            <span style="padding:0 10px; font-weight:700">{{ zeroCostPage }} / {{ zeroCostTotalPages }}</span>
            <button class="page-btn" :disabled="zeroCostPage>=zeroCostTotalPages" @click="gotoZeroCostPage(zeroCostPage+1)">›</button>
          </div>
          <button class="bc-btn-cancel" @click="showZeroCostModal = false">Yopish</button>
          <button class="bc-btn-apply" @click="loadZeroCost()" :disabled="zeroCostLoading">
            <b-icon icon="arrow-clockwise"></b-icon> Yangilash
          </button>
        </div>
      </div>
    </div>

    <!-- ═══════════════ ⚠️ TANNARX > SOTUV MODAL ═══════════════ -->
    <div v-if="showCostHighModal" class="bc-overlay" @click.self="showCostHighModal = false">
      <div class="bc-modal cost-high-modal">
        <div class="bc-head">
          <h3 class="bc-title">
            ⚠️ Tannarxi chakanadan oshib ketganlar
            <span v-if="!costHighLoading" class="dup-stats">({{ costHighTotal }} ta)</span>
          </h3>
          <button class="bc-close" @click="showCostHighModal = false">&times;</button>
        </div>

        <div class="bc-body">
          <!-- Qidiruv + saqlash -->
          <div class="zc-toolbar">
            <div class="search-wrapper" style="flex:1">
              <b-icon icon="search" class="search-icon"></b-icon>
              <input type="text" class="modern-search" style="width:100%"
                :placeholder="$t('Qidiruv...')" v-model="costHighKeyword" @input="onCostHighSearch" />
            </div>
            <div class="zc-pickedinfo" v-if="costHighEditedCount > 0">
              <b-icon icon="pencil-fill"></b-icon> {{ costHighEditedCount }} ta kiritildi
            </div>
            <button class="bc-btn-print" :disabled="costHighSaving || costHighEditedCount === 0"
              @click="saveCostHigh()">
              <b-icon :icon="costHighSaving ? 'arrow-repeat' : 'check-all'"></b-icon>
              {{ costHighSaving ? 'Saqlanmoqda...' : `Tuzatish (${costHighEditedCount})` }}
            </button>
          </div>

          <div class="zc-hint">
            Tannarx kiritilsa, shu mahsulotning <b>barcha</b> narx kartalari (eski tarix ham)
            + bog'liq partiyalar tannarxi tuzatiladi.
          </div>

          <div v-if="costHighLoading" class="text-center" style="padding:40px">
            <b-spinner variant="primary"></b-spinner>
            <div class="mt-2 text-muted">Yuklanmoqda...</div>
          </div>

          <div v-else-if="costHighList.length === 0" class="bc-empty" style="color:#10b981">
            ✅ Tannarxi chakana narxidan oshib ketgan mahsulot topilmadi.
          </div>

          <table v-else class="bc-table zc-table">
            <thead>
              <tr>
                <th style="width:40px">№</th>
                <th style="width:60px">ID</th>
                <th>Mahsulot</th>
                <th style="width:80px" class="th-right">Qoldiq</th>
                <th style="width:100px" class="th-right">Chakana</th>
                <th style="width:110px" class="th-right">Joriy tannarx</th>
                <th style="width:110px" class="th-right">Max tannarx</th>
                <th style="width:70px" class="th-right">Nisbat</th>
                <th style="width:150px">Yangi tannarx</th>
                <th style="width:100px">Valyuta</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(it, i) in costHighList" :key="it.id"
                :class="{ 'zc-edited': costNum(it) > 0 }">
                <td>{{ (costHighPage - 1) * costHighLimit + i + 1 }}</td>
                <td class="id-text" style="float:none">{{ it.id }}</td>
                <td>
                  <div class="bc-pname">{{ it.extra_name || it.name }}</div>
                  <div v-if="it.code" class="zc-code">{{ it.code }}</div>
                </td>
                <td class="td-right" :style="{ color: Number(it.balance) > 0 ? '#2563eb' : '#cbd5e1' }">
                  {{ it.balance | numFormat }}
                </td>
                <td class="td-right">{{ it.chakana_price | numFormat }}</td>
                <td class="td-right" style="color:#b45309">{{ it.latest_cost_sum | numFormat }}</td>
                <td class="td-right" style="color:#dc2626;font-weight:700">{{ it.max_cost_sum | numFormat }}</td>
                <td class="td-right">
                  <span class="ratio-badge">{{ Number(it.ratio).toFixed(1) }}×</span>
                </td>
                <td>
                  <input :value="it.new_body" type="text" inputmode="decimal"
                    class="zc-input"
                    :placeholder="it.min_cost_sum ? ('≈ ' + Math.round(Number(it.min_cost_sum))) : '0'"
                    @input="onCostInput(it, $event.target.value)"
                    @keyup.enter="focusNextCost(i)"
                    :ref="'costInput' + i" />
                </td>
                <td>
                  <select v-model.number="it.cost_currency" class="bc-select zc-cur">
                    <option :value="1">so'm</option>
                    <option :value="2">$</option>
                  </select>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="bc-foot">
          <div class="paginator" v-if="!costHighLoading && costHighTotalPages > 1" style="margin-right:auto">
            <button class="page-btn" :disabled="costHighPage<=1" @click="gotoCostHighPage(costHighPage-1)">‹</button>
            <span style="padding:0 10px; font-weight:700">{{ costHighPage }} / {{ costHighTotalPages }}</span>
            <button class="page-btn" :disabled="costHighPage>=costHighTotalPages" @click="gotoCostHighPage(costHighPage+1)">›</button>
          </div>
          <button class="bc-btn-cancel" @click="showCostHighModal = false">Yopish</button>
          <button class="bc-btn-apply" @click="loadCostHigh()" :disabled="costHighLoading">
            <b-icon icon="arrow-clockwise"></b-icon> Yangilash
          </button>
        </div>
      </div>
    </div>

    <!-- ═══════════════ YASHIRIN PRINT MARKUP ═══════════════ -->
    <div class="bc-mybody" style="display:none">
      <span v-for="(it, i) in barcodeSelection" :key="'p'+i">
        <template v-if="it.shtrix_kod && it.count > 0">
          <div v-for="n in Number(it.count)" :key="'p'+i+'-'+n" class="bc-page">
            <div class="bc-name">{{ it.name }}</div>
            <div v-if="barcodeShowPrice" class="bc-price">
              {{ Number(barcodePriceType === 'chakana' ? it.chakana_price : it.optom_price).toLocaleString('ru-RU') }} so'm
            </div>
            <div class="bc-barcode-wrap">
              <barcode :value="it.shtrix_kod" width="3.5" height="110" font-size="22" displayValue></barcode>
            </div>
          </div>
        </template>
      </span>
    </div>
  </div>
</template>
<script>
  import $ from "jquery";
  import VueAutoVirtualScrollList from "vue-auto-virtual-scroll-list";
  import VueBarcode from 'vue-barcode';
  export default {
    name: "product",
    components: { VueAutoVirtualScrollList, barcode: VueBarcode },
    data() {
      return {
        from: null,
        parent: 0,
        scrol: 0,
        add: false,
        page: 1,
        filter: "",
        limit: 50,
        totalCount: 0,
        list: [],
        update_password:"",
        sett: null,
        productlist: [],
        searchTimer: null,

        // 🗑 Ko'p o'chirish — tanlangan mahsulot id'lari
        selectedIds: [],
        bulkDeleting: false,

        // 🏷 Shtrix tanlash
        showBarcodeModal: false,
        barcodeSelection: [],        // [{ id, name, shtrix_kod, chakana_price, optom_price, count }]
        barcodePriceType: 'chakana',
        barcodeShowPrice: true,
        barcodeBulkCount: 1,
        autoGenerating: false,       // bulk avto-kod loading

        // 🔍 Dublikat shtrix modali
        showDupModal: false,
        dupLoading: false,
        dupFixing: false,
        dupGroups: [],               // [{ shtrix_kod, count, products: [{id, name, extra_name}] }]

        // 🛠 Narxlarni Excel'dan tuzatish
        showFixPricesModal: false,
        fixPricesFile: null,
        fixPricesLoading: false,
        fixPricesResult: null,       // { total_excel_rows, matched, updated, no_change, not_found, not_found_sample }

        // 0️⃣ Tannarxi 0 bo'lgan mahsulotlar
        showZeroCostModal: false,
        zeroCostLoading: false,
        zeroCostSaving: false,
        zeroCostList: [],            // [{ id, name, extra_name, code, balance, chakana_price, new_body, cost_currency }]
        zeroCostTotal: 0,
        zeroCostKeyword: "",
        zeroCostPage: 1,
        zeroCostLimit: 100,
        zeroCostSearchTimer: null,

        // ⚠️ Tannarx > Sotuv (chakana) — ro'yxat + barcha qatorlarni tuzatish
        showCostHighModal: false,
        costHighLoading: false,
        costHighSaving: false,
        costHighList: [],            // [{ id, name, extra_name, code, balance, chakana_price, latest_cost_sum, max_cost_sum, min_cost_sum, ratio, inflated_rows, new_body, cost_currency }]
        costHighTotal: 0,
        costHighKeyword: "",
        costHighPage: 1,
        costHighLimit: 100,
        costHighSearchTimer: null,
      };
    },
    computed: {
      // 🗑 Sahifadagi o'chirib bo'ladigan (harakati yo'q, papka emas) mahsulotlar
      deletableOnPage() {
        return this.productlist.filter(it => !it.is_folder && !it.used);
      },
      allPageSelected() {
        return this.deletableOnPage.length > 0
          && this.deletableOnPage.every(it => this.selectedIds.includes(it.id));
      },
      somePageSelected() {
        return this.deletableOnPage.some(it => this.selectedIds.includes(it.id));
      },
      // Dublikatlar bo'yicha jami mahsulotlar soni
      dupTotalProducts() {
        return this.dupGroups.reduce((s, g) => s + Number(g.count || 0), 0);
      },
      // 0️⃣ Tannarx kiritilgan (saqlanadigan) qatorlar soni
      zeroCostEditedCount() {
        return this.zeroCostList.filter(it => this.costNum(it) > 0).length;
      },
      zeroCostTotalPages() {
        return Math.max(1, Math.ceil(this.zeroCostTotal / this.zeroCostLimit));
      },
      // ⚠️ Tannarx kiritilgan (tuzatiladigan) qatorlar soni
      costHighEditedCount() {
        return this.costHighList.filter(it => this.costNum(it) > 0).length;
      },
      costHighTotalPages() {
        return Math.max(1, Math.ceil(this.costHighTotal / this.costHighLimit));
      },
      // Tanlangan ro'yxatdagi shtrix kodi bo'sh mahsulotlar soni
      emptyBarcodeCount() {
        return this.barcodeSelection.filter(it => !it.shtrix_kod).length;
      },
      // Avto-kod kerak bo'lgan mahsulotlar (bo'sh + tanlov ichida takrorlanadigan shtrix)
      autoFixIds() {
        const counts = {};
        for (const it of this.barcodeSelection) {
          const k = String(it.shtrix_kod || '').trim();
          if (k) counts[k] = (counts[k] || 0) + 1;
        }
        return this.barcodeSelection
          .filter(it => {
            const k = String(it.shtrix_kod || '').trim();
            return !k || counts[k] > 1;   // bo'sh yoki dublikat
          })
          .map(it => it.id);
      },
      autoFixCount() {
        return this.autoFixIds.length;
      },
      autoFixTitle() {
        if (this.autoFixCount === 0) {
          return 'Tanlangan barcha mahsulotlarga yangi noyob shtrix kod beriladi';
        }
        const empties = this.emptyBarcodeCount;
        const dups = this.autoFixCount - empties;
        const parts = [];
        if (empties > 0) parts.push(`${empties} ta bo'sh`);
        if (dups > 0) parts.push(`${dups} ta dublikat`);
        return `${parts.join(' + ')} shtrix yangilanadi`;
      },
      filterlist() {
        return this.productlist.slice(0, this.limit);
      },
      filteredRows() {
        return this.productlist;
      },
      totalPages() {
        return Math.max(1, Math.ceil(this.totalCount / this.limit));
      },
      visiblePages() {
        const total = this.totalPages;
        const cur = this.page;
        const win = 2;
        let start = Math.max(1, cur - win);
        let end = Math.min(total, cur + win);
        if (end - start < win * 2) {
          if (start === 1) end = Math.min(total, start + win * 2);
          else if (end === total) start = Math.max(1, end - win * 2);
        }
        const arr = [];
        for (let i = start; i <= end; i++) arr.push(i);
        return arr;
      }
    },
    methods: {
      // ════════ 🏷 SHTRIX TANLASH ════════
      // Berilgan mahsulot uchun tanlangan stikerlar soni (0 bo'lsa hech narsa)
      getBarcodeCount(productId) {
        const found = this.barcodeSelection.find(x => x.id === productId);
        return found ? Number(found.count || 0) : 0;
      },

      addToBarcodeSelection(item) {
        const idx = this.barcodeSelection.findIndex(x => x.id === item.id);
        if (idx >= 0) {
          this.barcodeSelection[idx].count += 1;
          return;
        }
        const entry = {
          id:    item.id,
          name:  item.extra_name || item.name || '—',
          shtrix_kod: '',
          chakana_price: (item.price_register && item.price_register.chakana_price) || 0,
          optom_price:   (item.price_register && item.price_register.optom_price)   || 0,
          count: 1,
        };
        // Shtrix kodni serverdan olib kelish
        axios.get(`api/v1/product/id/${item.id}`).then(r => {
          if (r.data && r.data.shtrix_table && r.data.shtrix_table[0]) {
            entry.shtrix_kod = r.data.shtrix_table[0].shtrix_kod || '';
          }
        }).catch(() => {});
        this.barcodeSelection.push(entry);
      },

      applyBarcodeBulk() {
        const n = Math.max(0, Math.floor(Number(this.barcodeBulkCount || 0)));
        this.barcodeSelection.forEach(it => {
          if (it.shtrix_kod) it.count = n;
        });
      },

      // ════════ 🛠 NARXLARNI TUZATISH (Excel) ════════
      openFixPricesModal() {
        this.fixPricesFile = null;
        this.fixPricesResult = null;
        this.showFixPricesModal = true;
      },
      resetFixPricesModal() {
        this.fixPricesFile = null;
        this.fixPricesResult = null;
      },
      onFixPricesFileChange(e) {
        const f = e.target.files && e.target.files[0];
        if (!f) return;
        const ok = /\.xlsx$/i.test(f.name);
        if (!ok) { alert('Faqat .xlsx fayl qabul qilinadi'); e.target.value = ''; return; }
        this.fixPricesFile = f;
        e.target.value = ''; // qayta tanlash uchun reset
      },
      async submitFixPrices() {
        if (!this.fixPricesFile) return;
        if (!confirm("Excel'dagi narxlar bilan bazadagi mahsulotlarning kelish/sotish narxlari yangilanadi. Davom etaylikmi?")) return;
        this.fixPricesLoading = true;
        try {
          const fd = new FormData();
          fd.append('file_name', this.fixPricesFile);
          const res = await axios.post('api/v1/upload/fix-product-prices-from-xlsx', fd, {
            headers: { 'Content-Type': 'multipart/form-data' },
          });
          this.fixPricesResult = res.data && (res.data.data || res.data);
        } catch (e) {
          console.error('Narxlarni tuzatishda xato:', e);
          const msg = (e.response && e.response.data && (e.response.data.message || e.response.data.error)) || e.message;
          alert("Xatolik: " + msg);
        } finally {
          this.fixPricesLoading = false;
        }
      },

      // ════════ 0️⃣ TANNARXI 0 BO'LGAN MAHSULOTLAR ════════
      openZeroCostModal() {
        this.showZeroCostModal = true;
        this.zeroCostPage = 1;
        this.zeroCostKeyword = "";
        this.loadZeroCost();
      },
      async loadZeroCost() {
        const sklad_id = localStorage.getItem("sklad_id");
        if (!(sklad_id > 0)) {
          this.zeroCostList = [];
          this.zeroCostTotal = 0;
          alert("Avval ombor (sklad) tanlang");
          return;
        }
        this.zeroCostLoading = true;
        try {
          const res = await axios.post("api/v1/product/zero-cost", {
            sklad_id,
            keyword: this.zeroCostKeyword,
            page: this.zeroCostPage,
            limit: this.zeroCostLimit,
          });
          const data = res.data || {};
          this.zeroCostTotal = Number(data.total || 0);
          this.zeroCostList = (data.items || []).map(it => ({
            ...it,
            new_body: '',
            cost_currency: 1,
          }));
        } catch (e) {
          console.error("Tannarxi 0 yuklashda xato:", e);
          alert("Yuklashda xatolik: " + (e.response && e.response.data && e.response.data.message || e.message));
          this.zeroCostList = [];
          this.zeroCostTotal = 0;
        } finally {
          this.zeroCostLoading = false;
        }
      },
      onZeroCostSearch() {
        clearTimeout(this.zeroCostSearchTimer);
        this.zeroCostSearchTimer = setTimeout(() => {
          this.zeroCostPage = 1;
          this.loadZeroCost();
        }, 350);
      },
      gotoZeroCostPage(p) {
        if (p < 1 || p > this.zeroCostTotalPages || p === this.zeroCostPage) return;
        this.zeroCostPage = p;
        this.loadZeroCost();
      },
      focusNextCost(i) {
        const next = this.$refs['costInput' + (i + 1)];
        const el = Array.isArray(next) ? next[0] : next;
        if (el && el.focus) el.focus();
      },
      // Tannarx inputi: yozish vaqtida ming ajratuvchi (bo'sh joy) qo'shadi.
      // Kasr ajratuvchisi vergul (ru-RU): masalan "1 500 000,5"
      formatSummaInput(val) {
        let s = String(val == null ? '' : val).replace(/\s/g, '').replace(',', '.');
        s = s.replace(/[^\d.]/g, '');
        const firstDot = s.indexOf('.');
        if (firstDot !== -1) {
          s = s.slice(0, firstDot + 1) + s.slice(firstDot + 1).replace(/\./g, '');
        }
        if (s === '' || s === '.') return s === '.' ? '0,' : '';
        const [intPart, decPart] = s.split('.');
        const intFmt = intPart ? Number(intPart).toLocaleString('ru-RU') : '0';
        return decPart !== undefined ? intFmt + ',' + decPart : intFmt;
      },
      parseSumma(val) {
        const cleaned = String(val == null ? '' : val).replace(/\s/g, '').replace(',', '.').replace(/[^\d.]/g, '');
        const n = parseFloat(cleaned);
        return isNaN(n) ? 0 : n;
      },
      costNum(it) {
        return this.parseSumma(it.new_body);
      },
      onCostInput(it, val) {
        it.new_body = this.formatSummaInput(val);
      },
      async saveZeroCost() {
        const sklad_id = localStorage.getItem("sklad_id");
        const items = this.zeroCostList
          .filter(it => this.costNum(it) > 0)
          .map(it => ({
            product_id: it.id,
            body_price: this.costNum(it),
            cost_currency: Number(it.cost_currency) || 1,
          }));
        if (items.length === 0) return;
        if (!confirm(`${items.length} ta mahsulotning tannarxi saqlanadi. Davom etaylikmi?`)) return;

        this.zeroCostSaving = true;
        try {
          const res = await axios.post("api/v1/product/bulk-set-cost", { sklad_id, items });
          const data = res.data || {};
          let msg = `✅ ${data.ok || 0} ta mahsulotning tannarxi saqlandi`;
          if (data.skipped) msg += `\n⚠️ ${data.skipped} ta o'tkazib yuborildi`;
          if (data.errors && data.errors.length) msg += `\n❌ ${data.errors.length} ta xatolik`;
          alert(msg);
          this.Cacheclear();
          await this.loadZeroCost();
        } catch (e) {
          console.error("Tannarx saqlashda xato:", e);
          alert("Saqlashda xatolik: " + (e.response && e.response.data && e.response.data.message || e.message));
        } finally {
          this.zeroCostSaving = false;
        }
      },

      // ════════ ⚠️ TANNARX > SOTUV (CHAKANA) ════════
      openCostHighModal() {
        this.showCostHighModal = true;
        this.costHighPage = 1;
        this.costHighKeyword = "";
        this.loadCostHigh();
      },
      async loadCostHigh() {
        const sklad_id = localStorage.getItem("sklad_id");
        if (!(sklad_id > 0)) {
          this.costHighList = [];
          this.costHighTotal = 0;
          alert("Avval ombor (sklad) tanlang");
          return;
        }
        this.costHighLoading = true;
        try {
          const res = await axios.post("api/v1/product/cost-exceeds-price", {
            sklad_id,
            keyword: this.costHighKeyword,
            page: this.costHighPage,
            limit: this.costHighLimit,
          });
          const data = res.data || {};
          this.costHighTotal = Number(data.total || 0);
          this.costHighList = (data.items || []).map(it => ({
            ...it,
            new_body: '',
            cost_currency: 1,
          }));
        } catch (e) {
          console.error("Tannarx > sotuv yuklashda xato:", e);
          alert("Yuklashda xatolik: " + (e.response && e.response.data && e.response.data.message || e.message));
          this.costHighList = [];
          this.costHighTotal = 0;
        } finally {
          this.costHighLoading = false;
        }
      },
      onCostHighSearch() {
        clearTimeout(this.costHighSearchTimer);
        this.costHighSearchTimer = setTimeout(() => {
          this.costHighPage = 1;
          this.loadCostHigh();
        }, 350);
      },
      gotoCostHighPage(p) {
        if (p < 1 || p > this.costHighTotalPages || p === this.costHighPage) return;
        this.costHighPage = p;
        this.loadCostHigh();
      },
      async saveCostHigh() {
        const sklad_id = localStorage.getItem("sklad_id");
        const items = this.costHighList
          .filter(it => this.costNum(it) > 0)
          .map(it => ({
            product_id: it.id,
            body_price: this.costNum(it),
            cost_currency: Number(it.cost_currency) || 1,
          }));
        if (items.length === 0) return;
        if (!confirm(`${items.length} ta mahsulotning BARCHA narx kartalari (eski tarix ham) tuzatiladi. Davom etaylikmi?`)) return;

        this.costHighSaving = true;
        try {
          const res = await axios.post("api/v1/product/bulk-fix-cost", { sklad_id, items });
          const data = res.data || {};
          let msg = `✅ ${data.ok || 0} ta mahsulot tuzatildi`;
          if (data.updated_rows) msg += ` (${data.updated_rows} ta karta, ${data.updated_series || 0} ta partiya)`;
          if (data.skipped) msg += `\n⚠️ ${data.skipped} ta o'tkazib yuborildi`;
          if (data.errors && data.errors.length) msg += `\n❌ ${data.errors.length} ta xatolik`;
          alert(msg);
          this.Cacheclear();
          await this.loadCostHigh();
        } catch (e) {
          console.error("Tannarx tuzatishda xato:", e);
          alert("Tuzatishda xatolik: " + (e.response && e.response.data && e.response.data.message || e.message));
        } finally {
          this.costHighSaving = false;
        }
      },

      // ════════ 🔍 DUBLIKAT SHTRIX ════════
      openDuplicateModal() {
        this.showDupModal = true;
        if (this.dupGroups.length === 0) this.loadDuplicates();
      },
      async loadDuplicates() {
        this.dupLoading = true;
        try {
          const res = await axios.get('api/v1/product/duplicate-shtrix');
          this.dupGroups = (res.data && res.data.items) || [];
        } catch (e) {
          console.error('Dublikatlarni yuklashda xato:', e);
          alert("Yuklashda xatolik: " + (e.response && e.response.data && e.response.data.message || e.message));
          this.dupGroups = [];
        } finally {
          this.dupLoading = false;
        }
      },
      // Bitta guruh ichidagi mahsulotlarga noyob shtrix berish
      async autoFixGroup(grp) {
        if (!grp || !grp.products || grp.products.length === 0) return;
        if (!confirm(`Shtrix "${grp.shtrix_kod}" — ${grp.products.length} ta mahsulotga noyob kod beriladi. Davom etaylikmi?`)) return;

        this.dupFixing = true;
        const items = grp.products.map(p => ({
          product_id: p.id,
          shtrix_kod: String(25 * 100000000000 + Number(p.id)),
        }));
        try {
          const res = await axios.post('api/v1/product/bulk-shtrix', { items });
          const okCount = (res && res.data && res.data.ok) || items.length;
          alert(`✅ ${okCount} ta mahsulotga noyob shtrix berildi`);
          await this.loadDuplicates();
        } catch (e) {
          alert("Tuzatishda xatolik: " + (e.response && e.response.data && e.response.data.message || e.message));
        } finally {
          this.dupFixing = false;
        }
      },
      // Barcha dublikat mahsulotlarga noyob shtrix berish
      async autoFixAllDuplicates() {
        const allItems = [];
        for (const g of this.dupGroups) {
          for (const p of g.products) {
            allItems.push({
              product_id: p.id,
              shtrix_kod: String(25 * 100000000000 + Number(p.id)),
            });
          }
        }
        if (allItems.length === 0) return;
        if (!confirm(`${this.dupGroups.length} ta guruh / ${allItems.length} ta mahsulotga noyob shtrix kod beriladi.\n\nDavom etaylikmi?`)) return;

        this.dupFixing = true;
        try {
          const res = await axios.post('api/v1/product/bulk-shtrix', { items: allItems });
          const okCount = (res && res.data && res.data.ok) || allItems.length;
          alert(`✅ ${okCount} ta mahsulotga noyob shtrix kod berildi`);
          await this.loadDuplicates();
        } catch (e) {
          alert("Tuzatishda xatolik: " + (e.response && e.response.data && e.response.data.message || e.message));
        } finally {
          this.dupFixing = false;
        }
      },

      // 🎯 Avto-kod: tanlangan, lekin shtrix kodi bo'sh yoki tanlov ichida takrorlanadigan
      // mahsulotlarga noyob shtrix beradi. Hech narsa yo'q bo'lsa, foydalanuvchi tasdiqlasa
      // tanlanganlarning hammasiga yangidan beradi.
      // Formula: 25 * 10^11 + product.id (product.id har doim noyob).
      async autoGenerateBarcodes() {
        if (this.barcodeSelection.length === 0) return;

        // Avval bo'sh + dublikat'larni topamiz
        let targets = this.barcodeSelection.filter(it => this.autoFixIds.includes(it.id));
        let msg;
        if (targets.length > 0) {
          const empties = this.emptyBarcodeCount;
          const dups = targets.length - empties;
          const parts = [];
          if (empties > 0) parts.push(`${empties} ta bo'sh`);
          if (dups > 0) parts.push(`${dups} ta dublikat`);
          msg = `${parts.join(' + ')} shtrix yangilanadi. Davom etaylikmi?\n\nFormula: 25 + mahsulot ID (noyob).`;
        } else {
          // Hammasi to'g'ri — ammo foydalanuvchi avto-kod bossa, tanlanganlarning hammasini qayta yaratamiz
          targets = this.barcodeSelection.slice();
          msg = `Tanlangan ${targets.length} ta mahsulotning shtrix kodlari ALMASHTIRILSINMI?\n\n⚠️ Eski shtrixlar o'chiriladi.\n\nFormula: 25 + mahsulot ID (noyob).`;
        }

        if (!confirm(msg)) return;

        this.autoGenerating = true;
        const items = targets.map(it => ({
          product_id: it.id,
          shtrix_kod: String(25 * 100000000000 + Number(it.id)),
        }));

        try {
          const res = await axios.post('api/v1/product/bulk-shtrix', { items });
          // Mahalliy ro'yxatda yangilash
          for (const it of items) {
            const row = this.barcodeSelection.find(x => x.id === it.product_id);
            if (row) row.shtrix_kod = it.shtrix_kod;
          }
          const okCount = (res && res.data && res.data.ok) || items.length;
          this.$store && this.$store.state && (this.$store.state.saved = 1);
          alert(`✅ ${okCount} ta mahsulotga noyob shtrix kod berildi`);
        } catch (e) {
          console.error('Bulk shtrix xatolik:', e);
          alert("Shtrix berishda xatolik: " + (e.response && e.response.data && e.response.data.message || e.message));
        } finally {
          this.autoGenerating = false;
        }
      },

      printBarcodes() {
        const valid = this.barcodeSelection.filter(it => it.shtrix_kod && Number(it.count) > 0);
        if (!valid.length) {
          alert("Shtrix kodli va soni > 0 bo'lgan mahsulot topilmadi");
          return;
        }
        this.$nextTick(() => {
          setTimeout(() => {
            const html = $('.bc-mybody').html();
            if (!html) { alert('Print markup tayyor emas'); return; }
            const w = window.open('', '_blank', 'width=420,height=700');
            w.document.write(`<!DOCTYPE html><html><head><meta charset="utf-8"><title>Shtrix</title>
              <style>
                /* Sticker o'lchami biroz kattaroq (58×40 → kontent kengayadi) */
                @page { size: 58mm 40mm; margin: 0; }
                * { box-sizing: border-box; }
                html, body { margin: 0; padding: 0; font-family: Arial, sans-serif; }
                .bc-page {
                  width: 58mm; height: 40mm;
                  page-break-after: always; page-break-inside: avoid;
                  display: flex; flex-direction: column;
                  align-items: center; justify-content: center;
                  gap: 0.5mm; padding: 1mm 0; overflow: hidden;
                }
                .bc-page:last-child { page-break-after: auto; }
                .bc-name {
                  font-size: 8pt; font-weight: 800;
                  text-align: center; line-height: 1.1;
                  max-height: 8mm; overflow: hidden;
                  width: 100%; word-break: break-word;
                  padding: 0 1mm;
                }
                .bc-price { font-size: 13pt; font-weight: 900; text-align: center; line-height: 1; }
                .bc-barcode-wrap {
                  width: 100%;
                  display: flex; justify-content: center; align-items: center;
                  flex: 1;
                  overflow: hidden;
                }
                /* Barcode butun stiker eniga sig'sin (chetlarsiz) */
                .vue-barcode-element {
                  width: 100% !important;
                  display: block;
                }
                .vue-barcode-element svg {
                  width: 100% !important;
                  height: auto !important;
                  max-height: 26mm;
                  display: block;
                  /* skanyer aniq o'qishi uchun antialiasing'siz */
                  image-rendering: -webkit-optimize-contrast;
                  image-rendering: crisp-edges;
                  shape-rendering: crispEdges;
                }
                .vue-barcode-element text {
                  font-size: 11pt !important;
                  font-weight: 800 !important;
                  letter-spacing: 1.2px;
                }
              </style>
              </head><body>${html}</body></html>`);
            w.document.close();
            // Print tugagandan keyin oynani avtomatik yopish
            w.onafterprint = () => { try { w.close(); } catch (_) {} };
            setTimeout(() => {
              w.focus();
              w.print();
              // Fallback: ba'zi brauzerlarda onafterprint ishlamaydi — 2 sek'da majburiy yopish
              setTimeout(() => { try { w.close(); } catch (_) {} }, 2000);
            }, 300);
          }, 100);
        });
      },

       Sklad() {
      let self = this;
      axios
        .get("api/v1/sklads/id/" + localStorage.getItem("sklad_id"))
        .then(function(response) {
          self.update_password = response.data.update_password;
      });
    },
      Add() {
        let self = this;
        self.page += 1;
        if (localStorage.getItem("sklad_id") > 0) {
          var datetime = null;
          var keyword = "";
          if (self.filter.length > 2) {
            keyword = self.filter;
          }
          axios({
            method: "post",
            url: "api/v1/product/all-price-balance/" + self.productlist[0].parent_id,
            data: {
              sklad_id: localStorage.getItem("sklad_id"),
              datetime: datetime,
              keyword: keyword,
              page: self.page,
              limit: self.limit
            }
          })
            .then(function (response) {
              var b = self.productlist.concat(response.data);
              self.productlist = b
              if (response.data.length == self.limit) {
              } else {
                self.add = false;
              }

            });
        }
      },
      List() {
        let self = this;
        axios.get("api/v1/product/extra-name").then(response => {
          self.list = response.data;
        });
      },
      Focus() {
        if (this.from.path == "/directory/product/create") {
          setTimeout(() => {
            var set = $(".item-name").not('.folder-name');
            if (set.length > 1) set[1].focus();
          }, 100);
        } else if (this.from.params.id) {
          this.$refs.inputText1.focus();
        } else {
          this.$refs.inputText1.focus();
        }
      },
      Select(item) {
        if (item.is_folder == false) {
          let val = item.id;
          this.$store.state.parent_id=item.parent_id;
          localStorage.setItem("setted_product", val);
          this.Cacheclear();
          window.close();
        } else {
          this.parent = item.parent_id;
          this.Productlist(item.id);
          setTimeout(() => {
            $('.item-name:eq(0)').focus()
          }, 100);
        }
      },
      Updateset(index) {
        let self = this;
        var id = self.filteredRowsRows[index].id;
        var table = $(":focus").parents("table:eq(0)");
        self.scrol = $(".table-wrapper").scrollTop();
        var focusable = table.find("tr");
        self.sett = focusable.index($(":focus").parents("tr"));
      },
      // 🗑 KO'P O'CHIRISH
      isSelected(id) {
        return this.selectedIds.includes(id);
      },
      toggleSelect(id) {
        const i = this.selectedIds.indexOf(id);
        if (i >= 0) this.selectedIds.splice(i, 1);
        else this.selectedIds.push(id);
      },
      toggleSelectAll(e) {
        const checked = e.target.checked;
        if (checked) {
          const ids = this.deletableOnPage.map(it => it.id);
          this.selectedIds = Array.from(new Set([...this.selectedIds, ...ids]));
        } else {
          const pageIds = new Set(this.deletableOnPage.map(it => it.id));
          this.selectedIds = this.selectedIds.filter(id => !pageIds.has(id));
        }
      },
      async bulkDelete() {
        if (this.selectedIds.length === 0) return;
        const text = await this.$prompt(this.$t("Паролни киритинг")).catch(() => null);
        if (text == null) return;
        if (text !== this.update_password) {
          this.$store.state.errors = this.$t("Парол хато");
          return;
        }
        if (!confirm(`Tanlangan ${this.selectedIds.length} ta mahsulot o'chiriladi. Davom etaylikmi?`)) return;

        this.bulkDeleting = true;
        try {
          const res = await axios.post("api/v1/product/bulk-delete", { ids: this.selectedIds });
          const data = res.data || {};
          const del = data.deleted_count != null ? data.deleted_count : (data.deleted || []).length;
          const skip = data.skipped_count != null ? data.skipped_count : (data.skipped || []).length;
          let msg = `✅ ${del} ta mahsulot o'chirildi`;
          if (skip > 0) msg += `\n⚠️ ${skip} ta o'chmadi (savdoda sotilgan)`;
          alert(msg);
          this.selectedIds = [];
          this.Cacheclear();
        } catch (e) {
          alert("O'chirishda xatolik: " + (e.response && e.response.data && (e.response.data.message || e.response.data) || e.message));
        } finally {
          this.bulkDeleting = false;
        }
      },
      Producttrash(id) {
        let self=this;
        self.$prompt(self.$t("Паролни киритинг")).then(text => {
          if (text == self.update_password) {
            let self = this;
            axios({
              method: "delete",
              url: "api/v1/product/id/" + id
            }).then(function (response) {
              self.Cacheclear();
              self.$store.dispatch("Productlist");
            });
          } else {
            self.$store.state.errors = self.$t("Парол хато");
          }
        })
        },
          Cacheclear() {
          let self = this;
          axios({
            method: "post",
            url: "api/v1/cache-clear/all-price-balance",
            data: {
              sklad_id: localStorage.getItem("sklad_id"),
          datetime: localStorage.getItem("created_at")
        }
      }).then(function (response) {
          self.Productlist(self.parent);
        });
    },
    onSearchInput() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.page = 1;
        this.Productlist(this.parent);
      }, 300);
    },
    onLimitChange() {
      this.page = 1;
      this.Productlist(this.parent);
    },
    gotoPage(p) {
      if (p < 1 || p > this.totalPages || p === this.page) return;
      this.page = p;
      this.Productlist(this.parent);
    },
    Productlist(parent) {
      let self = this;
      this.selectedIds = []; // navigatsiya/qidiruv/sahifa o'zgarsa tanlovni tozalaymiz
      if (!(localStorage.getItem("sklad_id") > 0)) {
        self.productlist = [];
        self.totalCount = 0;
        return;
      }
      var datetime = null;
      var keyword = "";
      if (self.filter.length > 2) keyword = self.filter;
      if (localStorage.getItem("created_at")) datetime = localStorage.getItem("created_at");

      const sklad_id = localStorage.getItem("sklad_id");
      const payload = {
        sklad_id, datetime, keyword,
        limit: self.limit,
        page: self.page,
      };

      axios.post("api/v1/product/all-price-balance/" + parent, payload).then(function (response) {
        self.productlist = response.data;
        if (response.data.length > 0 && response.data[0].parent_id > 0) {
          axios.get("api/v1/product/id/" + response.data[0].parent_id).then(function (r) {
            self.parent = r.data.parent_id;
          });
        }
      });

      axios.post("api/v1/product/all-price-balance-count", { sklad_id, keyword })
        .then(r => { self.totalCount = r.data.total || 0; })
        .catch(() => {});
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.from = from;
      vm.Focus();
    });
  },
  mounted: function() {
    let self = this;
    self.Productlist(this.$store.state.parent_id);
    this.Sklad();
    this.List();
  }
};
</script>

<style scoped>
/* SAHIFA ASOSI */
.g-page {
  padding: 20px;
  background: #f8fafc;
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.content-container {
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* HEADER */
.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.page-title {
  color: #a142f4;
  font-weight: 800;
  font-size: 26px;
  margin: 0;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* SEARCH */
.search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.search-icon {
  position: absolute;
  left: 12px;
  color: #94a3b8;
}

.modern-search {
  background: white;
  border: 1px solid #e2e8f0;
  padding: 8px 15px 8px 35px;
  border-radius: 12px;
  width: 250px;
  outline: none;
  transition: 0.3s;
}

.modern-search:focus {
  border-color: #a142f4;
  box-shadow: 0 0 0 4px rgba(161, 66, 244, 0.1);
}

/* TUGMALAR */
.add-btn {
  background: linear-gradient(135deg, #a142f4 0%, #8b2cf5 100%);
  color: white;
  border: none;
  height: 40px;
  padding: 0 20px;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 15px rgba(161, 66, 244, 0.3);
  transition: 0.2s;
}

.add-btn:hover {
  transform: translateY(-1px);
}

.add-btn sup {
  font-weight: 400;
  opacity: 0.7;
}

/* 🗑 KO'P O'CHIRISH TUGMASI */
.bulk-del-btn {
  background: #fff1f2;
  color: #e11d48;
  border: 1.5px solid #fecdd3;
  height: 40px;
  padding: 0 18px;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: 0.2s;
}
.bulk-del-btn:hover:not(:disabled) {
  background: #e11d48;
  color: white;
  border-color: #e11d48;
}
.bulk-del-btn:disabled { opacity: 0.6; cursor: not-allowed; }

/* Tanlash checkbox / lock */
.row-check {
  width: 17px;
  height: 17px;
  cursor: pointer;
  accent-color: #a142f4;
}
.lock-icon { color: #cbd5e1; font-size: 13px; }
.custom-table tbody tr.row-selected {
  background: #faf5ff !important;
}

/* JADVAL KARTASI */
.table-card {
  background: white;
  border-radius: 24px;
  padding: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
  border: 1px solid #f1f5f9;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.table-wrapper {
  overflow-y: auto;
  overflow-x: auto;
  flex: 1;
  min-height: 0;
  -webkit-overflow-scrolling: touch;
}
.table-wrapper::-webkit-scrollbar { width: 8px; height: 8px; }
.table-wrapper::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.custom-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.custom-table thead {
  position: sticky;
  top: 0;
  z-index: 5;
}

.custom-table th {
  background: white;
  padding: 16px 15px;
  color: #94a3b8;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 1px solid #f1f5f9;
}

.th-right {
  text-align: right;
}

.custom-table td {
  padding: 12px 15px;
  border-bottom: 1px solid #f8fafc;
  vertical-align: middle;
  font-size: 14px;
  color: #334155;
}

.td-right {
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.td-balance {
  font-weight: 700;
  color: #2c3e50;
}

/* TANNARX ustuni — dollar/so'm holati */
.cost-sum { font-weight: 700; color: #2c3e50; }
.cost-usd { font-weight: 800; color: #059669; white-space: nowrap; }
.cost-sub { display: block; font-size: 10px; font-weight: 600; color: #94a3b8; }

/* 🆕 Артикул ustun */
.td-code { text-align: center; }
.code-badge {
  display: inline-block;
  background: #ede9fe;
  color: #5850ec;
  font-family: 'JetBrains Mono', 'Consolas', monospace;
  font-weight: 700;
  font-size: 11px;
  padding: 3px 8px;
  border-radius: 6px;
  letter-spacing: 0.3px;
  white-space: nowrap;
}
.code-empty {
  color: #cbd5e1;
  font-size: 14px;
  font-weight: 600;
}

.custom-table tbody tr:hover:not(.navigation-row) {
  background: #faf8ff;
}

/* NAVIGATION */
.navigation-row {
  cursor: pointer;
}

.navigation-row:hover td {
  color: #a142f4;
  background: #faf8ff;
}

.go-back-btn {
  background: none;
  border: none;
  font-weight: 700;
  color: #94a3b8;
  font-size: 16px;
  cursor: pointer;
}

/* FOLDER */
.folder-row {
  background-color: #fffbeb;
}

.folder-row:hover {
  background-color: #fef3c7 !important;
}

.id-text {
  float: right;
  font-size: 12px;
  color: #94a3b8;
  font-weight: 600;
}

.item-name {
  background: none;
  border: none;
  font-weight: 600;
  color: #334155;
  font-size: 14px;
  cursor: pointer;
  text-align: left;
  padding: 0;
}

.folder-name {
  color: #d97706;
  font-weight: 700;
}

/* AMALLAR */
.actions {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.icon-btn {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s;
  cursor: pointer;
}

.edit {
  background: #eff6ff;
  color: #2563eb;
}

.edit:hover {
  background: #2563eb;
  color: white;
  transform: scale(1.1);
}

.del {
  background: #fff1f2;
  color: #e11d48;
}

.del:hover {
  background: #e11d48;
  color: white;
  transform: scale(1.1);
}

.copy {
  background: #f0fdf4;
  color: #16a34a;
}

.copy:hover {
  background: #16a34a;
  color: white;
  transform: scale(1.1);
}

/* KO'PROQ YUKLASH */
.load-more-row {
  text-align: center;
  padding: 15px !important;
}

.load-more-btn {
  background: #f0e6ff;
  color: #a142f4;
  border: none;
  padding: 8px 30px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: 0.2s;
}

.load-more-btn:hover {
  background: #a142f4;
  color: white;
}

/* FOOTER */
.table-footer {
  padding: 12px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  border-top: 1px solid #f1f5f9;
  color: #64748b;
  font-size: 13px;
  flex-wrap: wrap;
}
.table-footer .info {
  flex-shrink: 0;
}

.sep { margin: 0 6px; color: #cbd5e1; }
.paginator {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
}
.per-page {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-right: 8px;
  font-size: 13px;
  color: #64748b;
}
.per-page select {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 4px 8px;
  background: white;
  cursor: pointer;
  font-weight: 600;
}
.page-btn {
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  border: 1px solid #e2e8f0;
  background: white;
  border-radius: 8px;
  font-weight: 600;
  color: #475569;
  cursor: pointer;
  transition: 0.15s;
  font-size: 13px;
}
.page-btn:hover:not(:disabled):not(.active) {
  background: #faf5ff;
  border-color: #a142f4;
  color: #a142f4;
}
.page-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.page-btn.active {
  background: #a142f4;
  border-color: #a142f4;
  color: white;
  box-shadow: 0 2px 6px rgba(161, 66, 244, 0.3);
}
@media (max-width: 768px) {
  .table-footer {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }
  .paginator {
    justify-content: center;
  }
  .per-page { margin-right: 4px; }
  .page-btn { min-width: 28px; height: 28px; padding: 0 6px; font-size: 12px; }
}
@media (max-width: 480px) {
  .page-btn:not(.active):not([title]) { display: none; }
}
.empty-row {
  text-align: center;
  padding: 60px !important;
  color: #94a3b8;
  font-style: italic;
}

@media (max-width: 768px) {
  .g-page {
    padding: 10px;
  }

  .header-row {
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
  }

  .header-actions {
    flex-wrap: wrap;
  }
}

/* ═════════════ 🏷 SHTRIX TANLASH ═════════════ */
.barcode-fab {
  position: relative;
  /* Kattaroq tugma — yaxshi ko'rinadi va bosish oson */
  min-width: 56px; height: 48px;
  padding: 0 14px !important;
  border-radius: 12px;
  background: #fef3c7;
  color: #92400e;
  border: 1.5px solid #fbbf24;
  font-weight: 800;
  display: inline-flex; align-items: center; justify-content: center;
  cursor: pointer;
  transition: 0.15s;
}
.barcode-fab:hover {
  background: #fbbf24; color: white;
  transform: translateY(-1px);
}
.barcode-fab.active {
  background: linear-gradient(135deg, #5850ec, #4338ca) !important;
  color: white !important;
  border-color: #4338ca !important;
  box-shadow: 0 4px 14px rgba(88, 80, 236, 0.4);
}
.barcode-fab.active:hover { opacity: 0.92; }
.badge-count {
  position: absolute; top: -7px; right: -7px;
  background: #ef4444; color: white;
  font-size: 12px; font-weight: 900;
  min-width: 22px; height: 22px; padding: 0 6px;
  border-radius: 11px;
  display: flex; align-items: center; justify-content: center;
  border: 2px solid white;
  line-height: 1;
  box-shadow: 0 2px 6px rgba(239, 68, 68, 0.4);
}
.icon-btn.barcode {
  background: #fef3c7;
  color: #92400e;
  position: relative;
  transition: 0.15s;
}
.icon-btn.barcode:hover { background: #f59e0b; color: white; }

/* Tanlangan holat — yashil fon, "tanlangan" sifatida bildirib turadi */
.icon-btn.barcode.selected {
  background: linear-gradient(135deg, #10b981, #059669);
  color: white;
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.4);
}
.icon-btn.barcode.selected:hover {
  background: linear-gradient(135deg, #059669, #047857);
}

/* Satr ichidagi qizil badge (necha dona tanlangan) */
.row-badge {
  position: absolute;
  top: -7px; right: -7px;
  background: #ef4444;
  color: white;
  font-size: 10px; font-weight: 900;
  min-width: 18px; height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  display: flex; align-items: center; justify-content: center;
  border: 2px solid white;
  line-height: 1;
}

.bc-overlay {
  position: fixed; inset: 0;
  background: rgba(15,23,42,0.5);
  z-index: 9999;
  display: flex; align-items: center; justify-content: center;
  backdrop-filter: blur(3px);
}
.bc-modal {
  background: white; border-radius: 20px;
  width: 900px; max-width: 96vw; max-height: 90vh;
  display: flex; flex-direction: column; overflow: hidden;
  box-shadow: 0 24px 64px rgba(0,0,0,0.18);
}
.bc-head {
  padding: 18px 22px; border-bottom: 1px solid #f1f5f9;
  display: flex; justify-content: space-between; align-items: center;
}
.bc-title { margin: 0; font-size: 18px; font-weight: 800; color: #1e293b; }
.bc-close {
  background: #f1f5f9; border: none;
  width: 34px; height: 34px; border-radius: 50%;
  font-size: 22px; cursor: pointer; color: #64748b;
}
.bc-body { padding: 16px 22px; overflow-y: auto; flex: 1; }
.bc-foot {
  padding: 14px 22px; border-top: 1px solid #f1f5f9;
  display: flex; gap: 10px; justify-content: flex-end;
}
.bc-options {
  display: flex; align-items: center; gap: 16px;
  margin-bottom: 14px; padding: 10px 14px;
  background: #f8fafc; border-radius: 10px;
}
.bc-opt { display: flex; flex-direction: column; gap: 4px; }
.bc-label { font-size: 11px; font-weight: 700; color: #64748b; text-transform: uppercase; }
.bc-select {
  height: 36px; border: 1.5px solid #e2e8f0; border-radius: 8px;
  padding: 0 10px; font-size: 13px; font-weight: 600; cursor: pointer;
}
.bc-toggle { display: flex; align-items: center; gap: 6px; cursor: pointer; user-select: none;
  font-size: 13px; font-weight: 600; color: #475569;
}
.bc-bulk-row { display: flex; gap: 6px; align-items: center; }
.bc-btn-apply {
  background: linear-gradient(135deg, #5850ec, #4338ca);
  color: white; border: none;
  height: 32px; padding: 0 12px; border-radius: 8px;
  font-weight: 800; font-size: 12px; cursor: pointer;
}
.bc-btn-apply:hover { opacity: 0.92; }
.bc-btn-clear {
  background: #fff1f2; color: #e11d48; border: 1.5px solid #fda4af;
  height: 36px; padding: 0 14px; border-radius: 8px;
  font-weight: 700; font-size: 12px; cursor: pointer;
}
.bc-btn-clear:hover { background: #e11d48; color: white; }
.bc-btn-auto {
  background: linear-gradient(135deg, #10b981, #059669); color: white;
  border: none; height: 36px; padding: 0 14px; border-radius: 8px;
  font-weight: 700; font-size: 12px; cursor: pointer;
  display: inline-flex; align-items: center; gap: 6px;
  box-shadow: 0 2px 6px rgba(16, 185, 129, 0.25);
}
.bc-btn-auto:hover:not(:disabled) { opacity: 0.92; transform: translateY(-1px); }
.bc-btn-auto:disabled { opacity: 0.5; cursor: not-allowed; }

/* 🔍 Dublikat tab tugmasi (header) */
.dup-fab {
  background: linear-gradient(135deg, #f97316, #ea580c);
  color: white; border: none;
  padding: 0 14px; height: 42px; border-radius: 12px;
  font-weight: 700; font-size: 13px; cursor: pointer;
  display: inline-flex; align-items: center; gap: 6px;
  box-shadow: 0 4px 10px rgba(249, 115, 22, 0.25);
  transition: all 0.2s;
}
.dup-fab:hover { opacity: 0.92; transform: translateY(-1px); }
.dup-label { font-weight: 800; letter-spacing: 0.2px; }

/* 🛠 Narxlarni tuzatish tugmasi */
.fix-prices-fab {
  background: linear-gradient(135deg, #6366f1, #4f46e5);
  color: white; border: none;
  padding: 0 14px; height: 42px; border-radius: 12px;
  font-weight: 700; font-size: 13px; cursor: pointer;
  display: inline-flex; align-items: center; gap: 6px;
  box-shadow: 0 4px 10px rgba(99, 102, 241, 0.25);
  transition: all 0.2s;
}
.fix-prices-fab:hover { opacity: 0.92; transform: translateY(-1px); }
.fix-prices-label { font-weight: 800; letter-spacing: 0.2px; }

.fix-prices-modal { max-width: 640px; }
.fix-info { padding: 10px 4px; color: #475569; line-height: 1.5; }
.fix-info ul { margin: 8px 0 14px 18px; padding: 0; font-size: 13px; }
.fix-info ul li { margin-bottom: 4px; }
.fix-info code {
  background: #f1f5f9; padding: 1px 6px; border-radius: 4px;
  color: #5850ec; font-family: 'Courier New', monospace;
}
.fix-file-pick {
  display: flex; flex-direction: column; gap: 10px;
  margin-top: 12px; padding: 14px; border: 2px dashed #c7d2fe;
  border-radius: 12px; background: #eef2ff; align-items: center;
}
.fix-file-name {
  display: flex; align-items: center; gap: 8px;
  background: #fff; border: 1px solid #c7d2fe; border-radius: 8px;
  padding: 6px 12px; font-size: 13px; color: #4338ca;
}
.fix-clear-btn {
  background: none; border: none; color: #ef4444;
  font-size: 18px; font-weight: 700; cursor: pointer;
  padding: 0 4px; line-height: 1;
}
.fix-clear-btn:hover { color: #b91c1c; }

.fix-result { display: flex; flex-direction: column; gap: 8px; padding: 10px 4px; }
.fix-result-row {
  display: flex; align-items: center; gap: 10px;
  padding: 10px 14px; background: #f8fafc; border-radius: 8px;
  border-left: 3px solid #94a3b8; font-size: 14px;
}
.fix-result-row.ok    { border-left-color: #10b981; background: #ecfdf5; color: #065f46; }
.fix-result-row.warn  { border-left-color: #f59e0b; background: #fffbeb; color: #92400e; }
.fix-result-row b { font-weight: 800; }
.fix-notfound-list {
  margin-top: 10px; padding: 12px; background: #fff7ed;
  border: 1px solid #fed7aa; border-radius: 8px;
  max-height: 220px; overflow-y: auto; font-size: 12px;
}
.fix-notfound-list ul { margin: 6px 0; padding-left: 18px; }
.fix-notfound-list li { color: #9a3412; padding: 2px 0; }
.fix-notfound-list small { color: #78716c; display: block; margin-top: 6px; }

/* 0️⃣ Tannarxi 0 tugmasi + modal */
.zero-cost-fab {
  background: linear-gradient(135deg, #ef4444, #dc2626);
  color: white; border: none;
  padding: 0 14px; height: 42px; border-radius: 12px;
  font-weight: 700; font-size: 13px; cursor: pointer;
  display: inline-flex; align-items: center; gap: 6px;
  box-shadow: 0 4px 10px rgba(239, 68, 68, 0.25);
  transition: all 0.2s;
}
.zero-cost-fab:hover { opacity: 0.92; transform: translateY(-1px); }
.zero-cost-label { font-weight: 800; letter-spacing: 0.2px; }

.zero-cost-modal { max-width: 900px; }
.zc-toolbar {
  display: flex; align-items: center; gap: 12px; margin-bottom: 12px;
}
.zc-pickedinfo {
  display: inline-flex; align-items: center; gap: 6px;
  color: #5850ec; font-weight: 700; font-size: 13px;
  background: #eef2ff; padding: 6px 12px; border-radius: 8px;
}
.zc-table th, .zc-table td { vertical-align: middle; }
.zc-table tr.zc-edited { background: #ecfdf5; }
.zc-code {
  font-size: 11px; color: #5850ec; font-family: 'Courier New', monospace;
  background: #ede9fe; display: inline-block; padding: 1px 6px;
  border-radius: 5px; margin-top: 2px;
}
.zc-input {
  width: 100%; border: 1.5px solid #e2e8f0; border-radius: 8px;
  padding: 6px 10px; outline: none; font-weight: 700; font-size: 14px;
  text-align: right;
}
.zc-input:focus { border-color: #ef4444; box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.12); }
.zc-cur { width: 100%; }

/* ⚠️ Tannarx > Sotuv tugmasi + modal */
.cost-high-fab {
  background: linear-gradient(135deg, #f59e0b, #d97706);
  color: white; border: none;
  padding: 0 14px; height: 42px; border-radius: 12px;
  font-weight: 700; font-size: 13px; cursor: pointer;
  display: inline-flex; align-items: center; gap: 6px;
  box-shadow: 0 4px 10px rgba(245, 158, 11, 0.25);
  transition: all 0.2s;
}
.cost-high-fab:hover { opacity: 0.92; transform: translateY(-1px); }
.cost-high-label { font-weight: 800; letter-spacing: 0.2px; }
.cost-high-modal { max-width: 1080px; }
.zc-hint {
  font-size: 12px; color: #92400e; background: #fffbeb;
  border: 1px solid #fde68a; border-radius: 8px;
  padding: 8px 12px; margin-bottom: 12px;
}
.ratio-badge {
  display: inline-block; font-weight: 800; font-size: 12px;
  color: #991b1b; background: #fee2e2;
  padding: 2px 8px; border-radius: 999px;
}

/* Dublikat modal */
.dup-modal { max-width: 900px; }
.dup-stats { font-size: 13px; font-weight: 600; color: #64748b; margin-left: 8px; }
.dup-info-bar {
  display: flex; justify-content: space-between; align-items: center;
  gap: 12px; padding: 12px 14px; margin-bottom: 12px;
  background: linear-gradient(135deg, #fff7ed, #ffedd5);
  border: 1px solid #fdba74; border-radius: 10px;
  font-size: 13px; color: #9a3412;
}
.dup-info-bar code {
  background: #fff; padding: 2px 6px; border-radius: 4px;
  color: #c2410c; font-weight: 700;
}
.dup-list { display: flex; flex-direction: column; gap: 10px; max-height: 60vh; overflow-y: auto; }
.dup-group {
  background: #fff; border: 1.5px solid #fee2e2; border-radius: 10px;
  padding: 10px 12px;
}
.dup-group-head {
  display: flex; align-items: center; gap: 10px; padding-bottom: 8px;
  border-bottom: 1px dashed #fecaca; margin-bottom: 8px;
}
.dup-group-num {
  background: #fee2e2; color: #b91c1c;
  padding: 2px 8px; border-radius: 6px;
  font-size: 11px; font-weight: 800;
}
.dup-shtrix-tag {
  font-family: 'Courier New', monospace; font-weight: 800;
  color: #b91c1c; font-size: 14px;
}
.dup-count {
  background: #fef2f2; color: #991b1b;
  padding: 2px 10px; border-radius: 999px;
  font-size: 11px; font-weight: 700;
}
.dup-fix-group {
  margin-left: auto;
  background: #fff7ed; color: #c2410c; border: 1px solid #fed7aa;
  padding: 4px 10px; border-radius: 6px;
  font-size: 12px; font-weight: 700; cursor: pointer;
  display: inline-flex; align-items: center; gap: 4px;
}
.dup-fix-group:hover:not(:disabled) {
  background: linear-gradient(135deg, #f97316, #ea580c); color: white;
}
.dup-fix-group:disabled { opacity: 0.5; cursor: not-allowed; }
.dup-products {
  display: flex; flex-direction: column; gap: 4px;
}
.dup-product {
  display: flex; align-items: center; gap: 10px;
  padding: 4px 8px; background: #fafafa; border-radius: 6px;
  font-size: 13px;
}
.dup-pid {
  background: #e2e8f0; color: #475569;
  padding: 1px 7px; border-radius: 5px;
  font-size: 11px; font-weight: 700;
}
.dup-pname { color: #1e293b; }

.bc-empty { text-align: center; padding: 40px 20px; color: #94a3b8; font-weight: 600; }
.bc-table { width: 100%; border-collapse: collapse; }
.bc-table th {
  background: #f8fafc; padding: 10px;
  font-size: 11px; font-weight: 800; color: #64748b;
  text-transform: uppercase; text-align: left;
  border-bottom: 1.5px solid #e8edf3;
}
.bc-table td {
  padding: 10px; border-bottom: 1px solid #f1f5f9;
  font-size: 13px; color: #1e293b;
}
.bc-pname { font-weight: 700; }
.bc-warn { font-size: 11px; color: #b91c1c; font-weight: 700; margin-top: 2px; }
.bc-mono { font-family: 'JetBrains Mono', monospace; font-weight: 700; color: #5850ec; }
.bc-qty {
  width: 80px; height: 32px;
  border: 1.5px solid #e2e8f0; border-radius: 8px;
  padding: 0 10px; font-size: 14px; font-weight: 700;
  text-align: center; outline: none;
}
.bc-qty:focus { border-color: #5850ec; }
.bc-btn-x {
  background: #fff1f2; color: #e11d48;
  border: none; width: 30px; height: 30px;
  border-radius: 8px; cursor: pointer;
}
.bc-btn-x:hover { background: #e11d48; color: white; }
.bc-table tfoot td { background: #f1f5f9; padding: 12px 10px; }

.bc-btn-cancel {
  background: #f1f5f9; color: #64748b;
  border: none; height: 42px; padding: 0 20px;
  border-radius: 10px; font-weight: 700; cursor: pointer;
}
.bc-btn-print {
  background: linear-gradient(135deg, #10b981, #059669);
  color: white; border: none;
  height: 42px; padding: 0 24px;
  border-radius: 10px; font-weight: 800; cursor: pointer;
  display: flex; align-items: center; gap: 8px;
  box-shadow: 0 4px 14px rgba(16, 185, 129, 0.35);
}
.bc-btn-print:hover:not(:disabled) { opacity: 0.92; }
.bc-btn-print:disabled { opacity: 0.4; cursor: not-allowed; }
</style>
